import { css } from "@emotion/react"

export const overlayContainer = (columns, isMobile) => {
    if(isMobile){
        return css({
            display: 'flex',
            flexDirection: 'column',
            gap: 40
        })
    } else {
        return css({
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: 24,
        })
    }
}

export const column = {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
}

export const row = {
    display: 'flex',
    gap: 24,
}

export const link = (theme, isMobile) => css({
    fontFamily: theme.fonts.primaryCompressed,
    fontSize: isMobile ? 24 : 28,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '85%',
    textDecoration: 'none',
    textTransform: 'uppercase',
    color: '#000',
    transition: 'all .3s ease',
    ':hover':{
        opacity: .75,
        textDecoration: 'none',
    }
})

export const label = (theme, isMobile) => css({
    color: '#666666',
    fontFamily: theme.fonts.secondary,
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '140%',
    textTransform: 'uppercase',
})